import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
// Remplacer moment et dayjs par Luxon
//import { DateTime } from 'luxon'; // Utilisation de Luxon pour la gestion des dates

import { ToastrService } from 'ngx-toastr';
import { rapportsDir, dns } from 'src/app/global.config';
import {
  providers,
  reportOf,
} from 'src/app/client-management/import-export/report-item';
import {
  Group,
  ImportFileDto,
  RapportDto,
  VehiculesDto,
  PointInterest,
  PoiClient,
  ReportAuto,
} from '../../../../data-management/data-management.model';
import { DataManagementService } from '../../../../data-management/data-management.service';
import { rapportsItem } from '../../../../import-export/report-item';
import { NewImportExportRestService } from '../../../_service/new-import-export-rest.service';
import { NewImportExportHelperService } from '../../../_service/new-import-export-helper.service';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { User } from 'src/app/authentification/signin/credentials';
import { Router } from '@angular/router';
import { SigninService } from 'src/app/authentification/signin/signin.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AutoSendReportComponent } from '../../auto-send-report/auto-send-report.component';
@Component({
  selector: 'app-stop-poi-report',
  templateUrl: './stop-poi-report.component.html',
  styleUrls: ['./stop-poi-report.component.css']
})
export class StopPoiReportComponent implements OnInit {
file: Blob | null = null;
  vehicule$: Subscription;
isSending:boolean=false;

  multipleSelect = true;
  Selectedoption: string = 'ALL_VEHICULES';

  maxDate: Date = new Date();


duree: number ;
  isDateOnly = false;
  // locale: LocaleConfig = {
  //   format: 'DD/MM/YYYY HH:mm',
  //   applyLabel: 'Appliquer',
  //   customRangeLabel: ' - ',
  //   daysOfWeek: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  //   monthNames: [
  //     'Janvier',
  //     'Février',
  //     'Mars',
  //     'Avril',
  //     'Mai',
  //     'Juin',
  //     'Juillet',
  //     'Août',
  //     'Septembre',
  //     'Octobre',
  //     'Novembre',
  //     'Décembre',
  //   ],
  //   firstDay: 1,
  // };

  //Selectedoption: string = 'ALL_VEHICULES';
  isShowingExcel: boolean = false;
  loading: boolean = true;

  currentReport: void;
  groups: Group[] = [];
  vehicules: VehiculesDto[] = [];
  groupsItems: { id: number; text: string }[] = [];
  selectedGroupsItems: any[] = [];
  vehiculesSelected: any[] = [];
  vehiculesItems: { id: number; text: string }[] = [];
  selectedVehicule: { id: number; text: string }[] = [];
  poiName: PointInterest[];

  selectedGroupsHash: string = '';
  selectedVehiculesHash: string = '';

  selectReportOf = reportOf;

  isDownloading: boolean = false;
  repport: RapportDto = new RapportDto();
  templateDownloadLocation: string = rapportsDir;
  selectedPoi: string[] = [];
filteredPoi: any[] = []; // liste des POI, ex: [{ name: 'POI1' }, { name: 'POI2' }, ...]
dailyStop:boolean
  constructor(
    private importExportRestService: NewImportExportRestService,
    private importExportHelperService: NewImportExportHelperService,
    private importExportService: NewImportExportService,
    public dataManagementService: DataManagementService,
    private toastr: ToastrService,private dialog:MatDialog

  ) {}

  ngOnInit(): void {
    this.Selectedoption = 'ALL_VEHICULES';
    this.getGroups();
    this.getVehicules();
    this.multipleSelect = true;
    this.selectReportOf = reportOf;

    

    this.importExportService.setPdfExistince(false);
    // this.showExcel();
    var toDay = new Date();
    this.repport.dateInterval.startDate = new Date(
      toDay.getFullYear(),
      toDay.getMonth(),
      toDay.getDate(),
      0,
      0,
      0,
      0
    );
    this.repport.dateInterval.endDate = new Date(
      toDay.getFullYear(),
      toDay.getMonth(),
      toDay.getDate(),
      23,
      59,
      59,
      59
    );
    this.repport.dateInterval.startDate.setTime(
      this.repport.dateInterval.startDate.getTime()
    );

    this.dataManagementService.getAllGroupsDetails('').subscribe((res) => {
      this.groups = res.filter((group) => group.vehicules.length > 0);
      this.mapGroupsToItems(this.groups);
      if (this.groups) {
        this.getVehicules();
      }
    });

     this.importExportService.isSending().subscribe((s)=>{
      this.isSending=s
    })



   this.dataManagementService
  .getListNamesOfPointInterests()
  .subscribe((res) => {
    this.poiName = res;
    this.filteredPoi = Array.isArray(this.poiName)
      ? this.poiName.filter((p) => p.type === 'MARKER')
      : [];
    this.filteredPoiSearch = this.filteredPoi;
  });

      this.importExportService.isDailyStop().subscribe((d)=>{
        this.dailyStop=d
        console.log(d)
        if(d){
          this.repport.type="DAILY_STOP_BY_POI"

        }else{
          this.repport.type="STOP_BY_POI"
          this.repport.byPOI=true
        }
      })
  }
openAutoSend(){
    this.dialog.open(AutoSendReportComponent,{
      width:"600px",
            data:{repport:this.repport}
    })

  }


onSelectingPoi() {
    console.log('POI sélectionnés :', this.selectedPoi);
    this.repport.rapportPayloadDto.poiAdresses = this.selectedPoi;
}

  mapGroupsToItems(groups: Group[]) {
    this.groupsItems = [];
    for (let i = 0; i < groups.length; i++) {
      let parentName: string;
      if (groups[i].nameGroupParent) {
        parentName = groups[i].nameGroupParent + ' / ' + groups[i].nom;
      } else {
        parentName = groups[i].nom;
      }
      this.groupsItems.push({
        id: groups[i].idGroupe,
        text: parentName,
      });
    }
  }

  ngOnDestroy(): void {
    if (this.vehicule$) {
      this.vehicule$.unsubscribe();
    }
    this.importExportService.setShowPdf(false);
  }

  onSelectingReportOf() {
    /**give ability to downoald */

    this.loading = true;
    switch (this.Selectedoption) {
      case 'ALL_VEHICULES':
        this.repport.rapportPayloadDto.allVehicules = true;
        this.repport.rapportPayloadDto.byGroups = false;
        this.repport.rapportPayloadDto.byVehicules = false;
        this.importExportService.setByVehicule(true)
        break;
      case 'BY_GROUPS':
        this.repport.rapportPayloadDto.allVehicules = false;
        this.repport.rapportPayloadDto.byGroups = true;
        this.repport.rapportPayloadDto.byVehicules = false;
                this.importExportService.setByVehicule(false)

        break;
      case 'BY_VEHICULE':
        this.repport.rapportPayloadDto.allVehicules = false;
        this.repport.rapportPayloadDto.byGroups = false;
        this.repport.rapportPayloadDto.byVehicules = true;
                this.importExportService.setByVehicule(true)

        break;
      default:
        this.repport.rapportPayloadDto.allVehicules = true;
    }
  }

  selectedGroups(groups: { id: number; text: string }[]): void {
    let prefix = '';
    this.selectedGroupsHash = '';
    groups.forEach((group) => {
      this.selectedGroupsHash += prefix + group.id;
      prefix = ',';
    });
    this.repport.rapportPayloadDto.idGroups = this.selectedGroupsHash
      .split(',')
      .map((x) => +x);
  }

  selectedVehicules(vehicules: { id: number; text: string }[]): void {
    let prefix = '';
    this.selectedVehiculesHash = '';
    vehicules.forEach((vehicule) => {
      this.selectedVehiculesHash += prefix + vehicule.id;
      prefix = ',';
    });
    this.repport.rapportPayloadDto.idVehicules = this.selectedVehiculesHash
      .split(',')
      .map((x) => +x);
  }

  getGroups(): void {
    this.importExportRestService.getAllGroups().subscribe((groups) => {
      this.groups = groups;
      this.groupsToItems(groups);
    });
  }

  getVehicules(): void {
    this.importExportRestService.getAllVehicules().subscribe((vehicules) => {
      this.vehicules = vehicules;
      this.vehiculesToItems(vehicules);
    });
  }

  groupsToItems(groups: Group[]): void {
    this.groupsItems = groups.map((group) => ({
      id: group.idGroupe,
      text: group.nom,
    }));
  }

  vehiculesToItems(vehicules: VehiculesDto[]): void {
    this.vehiculesItems = vehicules.map((vehicule) => ({
      id: vehicule.idVehicule,
      text: vehicule.matricule,
    }));
  }

  showExcel(): void {
  
    this.isShowingExcel = true;

   if (this.repport.rapportPayloadDto.byGroups) {
  this.repport.rapportPayloadDto.idGroups = this.selectedGroupsItems.map((g) => g.id);
}
if (this.repport.rapportPayloadDto.byVehicules) {
  this.repport.rapportPayloadDto.idVehicules = this.vehiculesSelected.map((v) => v.id);
}
      this.repport.duration=this.duree

   this.importExportRestService.getStopReport(this.repport).subscribe(
      (blob) => {
        if (blob != null) {
          this.importExportService.setExcelToBeProcessed(blob);
          this.importExportService.setShowPdf(true);
          this.file = blob;
          this.isShowingExcel = false;
          this.toastr.success('Fichier chargé avec succès.');
        } else {
          this.isShowingExcel = false;
          this.toastr.warning('Aucune donnée correspondante.');
        }
      },
      (error) => {
        this.isShowingExcel = false;
        this.toastr.warning('Aucune donnée correspondante.');
      }
    ); 
  }
// --- Dropdown POI ---
isPoiDropdownOpen = false;
poiSearchText = '';
filteredPoiSearch: any[] = [];

togglePoiDropdown(): void {
  this.isPoiDropdownOpen = !this.isPoiDropdownOpen;
  if (this.isPoiDropdownOpen) {
    this.poiSearchText = '';
    this.filteredPoiSearch = this.filteredPoi;
  }
}

onPoiSearchChange(): void {
  const term = this.poiSearchText.toLowerCase();
  this.filteredPoiSearch = this.filteredPoi.filter((p) =>
    p.name.toLowerCase().includes(term)
  );
}

isPoiChecked(poi: any): boolean {
  return this.selectedPoi.includes(poi.name);
}

togglePoiCheck(poi: any): void {
  const index = this.selectedPoi.indexOf(poi.name);
  if (index > -1) {
    this.selectedPoi.splice(index, 1);
  } else {
    this.selectedPoi.push(poi.name);
  }
  this.onSelectingPoi();
}

isAllPoiSelected(): boolean {
  return (
    this.filteredPoi.length > 0 &&
    this.selectedPoi.length === this.filteredPoi.length
  );
}

toggleSelectAllPoi(): void {
  this.selectedPoi = this.isAllPoiSelected() ? [] : this.filteredPoi.map((p) => p.name);
  this.onSelectingPoi();
}

getSelectedPoiDisplay(): string {
  if (!this.selectedPoi || this.selectedPoi.length === 0) {
    return 'Aucun POI';
  }
  const displayed = this.selectedPoi.slice(0, 2);
  const additionalCount = this.selectedPoi.length - displayed.length;
  return displayed.join(', ') + (additionalCount > 0 ? ` (+${additionalCount} autres)` : '');
}
  // --- Dropdown Groupes ---
isGroupsDropdownOpen = false;
groupsSearchText = '';
filteredGroupsItems: { id: number; text: string }[] = [];

toggleGroupsDropdown(): void {
  this.isGroupsDropdownOpen = !this.isGroupsDropdownOpen;
  if (this.isGroupsDropdownOpen) {
    this.groupsSearchText = '';
    this.filteredGroupsItems = this.groupsItems;
  }
}

onGroupsSearchChange(): void {
  const term = this.groupsSearchText.toLowerCase();
  this.filteredGroupsItems = this.groupsItems.filter((g) =>
    g.text.toLowerCase().includes(term)
  );
}

isGroupChecked(group: { id: number; text: string }): boolean {
  return this.selectedGroupsItems.some((g) => g.id === group.id);
}

toggleGroupCheck(group: { id: number; text: string }): void {
  const index = this.selectedGroupsItems.findIndex((g) => g.id === group.id);
  if (index > -1) {
    this.selectedGroupsItems.splice(index, 1);
  } else {
    this.selectedGroupsItems.push(group);
  }
  this.selectedGroups(this.selectedGroupsItems);
}

isAllGroupsSelected(): boolean {
  return (
    this.groupsItems.length > 0 &&
    this.selectedGroupsItems.length === this.groupsItems.length
  );
}

toggleSelectAllGroups(): void {
  this.selectedGroupsItems = this.isAllGroupsSelected() ? [] : [...this.groupsItems];
  this.selectedGroups(this.selectedGroupsItems);
}

// --- Dropdown Véhicules ---
isVehiculesDropdownOpen = false;
vehiculesSearchText = '';
filteredVehiculesItems: { id: number; text: string }[] = [];

toggleVehiculesDropdown(): void {
  this.isVehiculesDropdownOpen = !this.isVehiculesDropdownOpen;
  if (this.isVehiculesDropdownOpen) {
    this.vehiculesSearchText = '';
    this.filteredVehiculesItems = this.vehiculesItems;
  }
}

onVehiculesSearchChange(): void {
  const term = this.vehiculesSearchText.toLowerCase();
  this.filteredVehiculesItems = this.vehiculesItems.filter((v) =>
    v.text.toLowerCase().includes(term)
  );
}

isVehiculeChecked(vehicule: { id: number; text: string }): boolean {
  return this.vehiculesSelected.some((v) => v.id === vehicule.id);
}

toggleVehiculeCheck(vehicule: { id: number; text: string }): void {
  const index = this.vehiculesSelected.findIndex((v) => v.id === vehicule.id);
  if (index > -1) {
    this.vehiculesSelected.splice(index, 1);
  } else {
    this.vehiculesSelected.push(vehicule);
  }
  this.selectedVehicules(this.vehiculesSelected);
}

isAllVehiculesSelected(): boolean {
  return (
    this.vehiculesItems.length > 0 &&
    this.vehiculesSelected.length === this.vehiculesItems.length
  );
}

toggleSelectAllVehicules(): void {
  this.vehiculesSelected = this.isAllVehiculesSelected() ? [] : [...this.vehiculesItems];
  this.selectedVehicules(this.vehiculesSelected);
}

getSelectedVehiculesDisplay(): string {
  if (!this.vehiculesSelected || this.vehiculesSelected.length === 0) {
    return 'Aucun véhicule sélectionné';
  }
  const displayed = this.vehiculesSelected.slice(0, 2).map((v) => v.text);
  const additionalCount = this.vehiculesSelected.length - displayed.length;
  return displayed.join(', ') + (additionalCount > 0 ? ` (+${additionalCount} autres)` : '');
}

  downloadExcel(): void {
    console.log(this.selectedGroupsItems)
    console.log(this.vehiculesSelected)
    this.repport.duration=this.duree
    this.isDownloading = true;
  if (this.repport.rapportPayloadDto.byGroups) {
  this.repport.rapportPayloadDto.idGroups = this.selectedGroupsItems.map((g) => g.id);
}
if (this.repport.rapportPayloadDto.byVehicules) {
  this.repport.rapportPayloadDto.idVehicules = this.vehiculesSelected.map((v) => v.id);
}

   this.importExportRestService.getStopReport(this.repport).subscribe(
      (blob) => {
        //this.importExportService.setExcelToBeProcessed(blob);
        this.file = blob;
        this.isDownloading = false;
        this.importExportHelperService.downloadEasyPDF(
          blob,
          this.dailyStop?"Rapport_Arrets_POI_Journalier.xlsx":"Rapport_Arrets_POI.xlsx"
        );

        this.toastr.success('Fichier téléchargé avec succès.');
      },
      (error) => {
        this.isDownloading = false;
        this.toastr.warning('Problème survenu lors du téléchargement.');
      }
    ); 
  }

  setTimeTo2359() {
    // Check if endDate is set and not just an empty string
    if (this.repport.dateInterval.endDate) {
      // Set the time to 23:59
      this.repport.dateInterval.endDate.setHours(23);
      this.repport.dateInterval.endDate.setMinutes(59);
    }
  }

  getSelectedGroupsDisplay(): string {
    if (!this.selectedGroupsItems || this.selectedGroupsItems.length === 0) {
      return 'Aucun groupe sélectionné';
    }
    const displayedGroups = this.selectedGroupsItems
      .slice(0, 2)
      .map((group) => group.text);
    const additionalCount =
      this.selectedGroupsItems.length - displayedGroups.length;
    return (
      displayedGroups.join(', ') +
      (additionalCount > 0 ? ` (+${additionalCount} autres)` : '')
    );
  }
  
}
